import Ayudaboton from './Ayudaboton'
import PrincipalContainer from './PrincipalContainer'
import HomeBuscador from "./componentesHTML/componentesSecundarios/HomeBuscador";

const PrincipalBuscador = () => {
    const homeBusca = (() => {
        const timerId = setTimeout(() => {
            HomeBuscador.valida();
        }, 500);
        return () => {
        clearTimeout(timerId);
        };
    });
    return (
        <>
        {/* <StoreProvider>
            <Buscador />
        </StoreProvider> */}
        
        <Ayudaboton />
        <PrincipalContainer /> 
            {
                homeBusca()
            }
        </>
    )
}
export default PrincipalBuscador;